import React, { Component } from "react";

import { v1 as uuidv1 } from 'uuid';
import { translate } from "../../../utils/useful";
import FormViewer from "../../FormViewer";

class FormBuilderInputEdit extends Component {
    state = {
    };

    // // init = () => {

    // // }

    // liveChange=(data, init, key, value, extra)=>{
    //     if(!init){
    //         this.props.updateInputData(key,value)
    //     }
    // }

    // validateForm=(cb)=>{
    //     let data = this.form.getForm()
    //     if(data){
    //         cb(true)
    //     }else{
    //         cb(false)
    //     }
    // }

    // componentDidMount() {

    //     console.log('aksgyxtusafgctyfty')
    //     let formdata = this.props.initData.formdata.headers
    //     console.log('aksgyxtusafgctyfty', formdata)
    // }

    addInput = () => {
        let data = this.form.getForm()
        // console.log("dataaaaaaaaaaaaaaaainput--0-0-0-0-00-", data)
        console.log(this.props.initData.formdata)
        let input = this.convertItem({ ...this.props.initData.formdata })
        input.information = data
        console.log(input)

        this.props.setField(input)
        // return
        // if(data){
        //     this.props.setData(data)
        // }
    }



    convertItem = (item) => {
        let information = {}
        if (item.headers) {
            item.headers.forEach(header => {

                if ((typeof header.information.defaultValue == 'object') || (header.information.defaultValue != null && header.information.defaultValue != '')) {
                    // console.log(header.information.defaultValue)

                    information[header.key] = header.information.defaultValue
                }
            });
            let guid = uuidv1()
            // console.log(guid)
            return { type: item.type, key: guid, information: information }
        } else {
            return item
        }
    };


    render() {


        return (
            <div className="w-100 h-100 bg-white pb-3">
                {console.log('item', this.props.item)}
                {/* <div className="px-3 w-100">
                    <div className=" mb-2 pb-2" style={{ borderBottom: '1px solid #f2f6f8' }}>
                        <div className="flexc">
                            <img src={this.props.input?.icon} height={20} />
                            <p className="mld-2 text-normal text-semibold">{translate(this.props.input?.label)}</p>
                        </div>
                        <p className="text-smaller  ">Configuration</p>
                    </div>
                </div> */}
                <div className="w-100 px-3 pb-3 pt-3 mb-3 flexc" style={{ background: 'linear-gradient(to right, #4685cccb, #4646cc)', backgroundColor: '#4646cc' }}>
                    <div className="flexcb w-100">
                        <div className='mrd-2 flexcc'>
                            {/* <button onClick={() => this.props.lastStage()} className='px-1 py-1  flexcc' style={{ filter: 'saturate(20%) ', background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                <div className='flexcc  p-1' style={{ borderRadius: 10 }}>
                                    <img className='invert rotate-180' src='/assets/icons/angle-right.svg' height={18} />
                                </div>
                            </button> */}
                            {/* <p className="color-white text-normal text-bold color-gray-3 m-0 mx-1">From Config</p> */}
                        </div>
                        <button onClick={() => this.addInput()} className="flexcb p-1 " style={{ borderRadius: 9, border: '1px solid #d8d8d8cd' }}>
                            {/* onClick={() => this.props.changeStage('form')} disabled={this.props.services?.products?.length == 0} */}
                            <div className="px-2" style={{}} >
                                <p style={{ color: '#fafafa' }}>{translate(`edit`)}</p>
                            </div>
                            <div className=' default-btn-icon  ws-25 hs-25 flexcc' style={{}}>
                                <img className='invert' src="/assets/icons/useful/angle-right.svg" height={20} />
                            </div>
                        </button>
                    </div>
                </div>

                <div className="scroll-no-scrollbar">
                    <FormViewer ref={el => this.form = el} liveChange={this.liveChange} headers={this.props.item.formdata.headers} initData={{}} errors={this.state.errors} formClass="modern" inputClass={'modern-input'} variables={this.props.item.information} />
                </div>

            </div>
        );
    }
}

export default FormBuilderInputEdit;
